import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GolfHeadToHeadPageComponent } from './golf-head-to-head-page/golf-head-to-head-page.component';
import { GolfRankingsPageComponent } from './golf-rankings-page/golf-rankings-page.component';
import { GolfTournamentPageComponent } from './golf-tournament-page/golf-tournament-page.component';

const routes: Routes = [
	{path: "next", component: GolfTournamentPageComponent},
	{path: "h2h", component: GolfHeadToHeadPageComponent},
	{path: "rankings", component: GolfRankingsPageComponent},

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GolfRoutingModule { }
